export default __webpack_public_path__ + "4914720255ab85c0b5d345fd978fa753.png";